<template>
    <div class="login-page">
        <br/>
        <br/>
        <br/>
        <b-form @submit="onSubmitSignin">
            <b-container>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="login-usertype-group" label-for="login-usertype-select" label="User Type:">
                            <b-form-select id="login-usertype-select" v-model="form.selected" :options="form.users"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="login-username-group" label-for="login-username-input" label="Username:">
                            <b-form-input id="login-username-input" type="text" placeholder="Enter Username" v-model="form.username"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="login-password-group" label-for="login-password-input" label="Password:">
                            <b-form-input id="login-password-input" type="password" placeholder="Enter Password" v-model="form.password"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="login-remember-group">
                            <b-form-checkbox id="login-remember-input">Remember Me</b-form-checkbox>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center" v-if="hasError">
                    <b-col cols="6">
                        <span>{{errorMessage}}</span>
                        <br/>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-button type="submit" variant="primary">Submit</b-button>
                        <b-link @click="onForgotPassword">Forgot password?</b-link>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <span>Get started - </span><b-link to="/account/signup">Signup</b-link>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
        <div class="mt-3">
            <b-container>
                <b-row align-h="center">
                    <b-col cols="6">
                            <div id="signin-recaptcha" class="g-recaptcha" data-sitekey=process.env.RECAPTCHA_SITE_KEY></div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <b-form @submit="onSubmitConfirmation" v-if="needsConfirmation === true">
            <br/>
            <br/>
            <b-container>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="login-confirmation-group" label-for="login-confirmation-select" label="Confirmation:">
                            <b-form-input id="login-confirmation-input" type="text" placeholder="Enter Confirmation Code" v-model="form.confirmationCode"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-button type="submit" variant="primary">Submit</b-button>
                        <b-button type="button" variant="secondary" @click="onResendConfirmation">Resend</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
    </div>
</template>
<script>
    import User from '../../user.js';

    export default
    {
        name: 'Login',
        data()
        {
            return {
                needsConfirmation: false,
                hasError:          false,
                errorMessage:      '',
                form: {
                    username:           '',
                    password:           '',
                    checked:            false,
                    selected:           null,
                    confirmationCode:   '',
                    users:              User.UserEnum.properties
                }
            }
        },
        methods: {
            onSubmitSignin,
            onSubmitConfirmation,
            onResendConfirmation,
            onForgotPassword
        },
        mounted: onMounted
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onSubmitSignin( event )
    {
        this.needsConfirmation = false;
        this.hasError          = false;
        this.errorMessage      = '';

        signIn( this );
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onForgotPassword( event )
    {
        switch( this.form.selected )
        {
        case User.UserEnum.PATIENT:
            this.$router.push( '/patient/forgot-password' );
            break;
        case User.UserEnum.PROVIDER:
            this.$router.push( '/provider/forgot-password' );
            break;
        default:
            break;
        }
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onSubmitConfirmation( event )
    {
        var _this = this;
        User.confirm(
                this.form.username,
                this.form.confirmationCode,
                this.form.selected,
                function successCallback()
                {
                    signIn( _this );
                },
                function failureCallback( error )
                {
                    _this.hasError     = true;
                    _this.errorMessage = 'A confirmation error has occurred.';
                    if( typeof( error.response.data.Error.code ) !== 'undefined' )
                    {
                        switch( error.response.data.Error.code )
                        {
                        case "UserNotConfirmedException":
                            _this.errorMessage            = 'User needs to be confirmed.';
                            _this.needsConfirmation = true;
                            break;
                        }
                    }
                }
            );
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onResendConfirmation( event )
    {
        var _this = this;
        User.resendVerificationCode(
                this.form.username,
                this.form.selected,
                function successCallback()
                {
                    _this.hasError     = false;
                    _this.errorMessage = '';
                },
                function failureCallback( error )
                {
                    _this.hasError     = true;
                    _this.errorMessage = 'An error occurred while attempting to resend a confirmation code.';
                }
            );
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function signIn( component )
    {
        try
        {
            var recaptchaResponse = grecaptcha.getResponse( component.recaptchaID );
            if( recaptchaResponse.length === 0 )
            {
                component.hasError     = true;
                component.errorMessage = "Please verify that you're human.";
                return;
            }

            // CORS Issue
            // https://github.com/github/fetch/issues/386
            if( component.form.selected === null )
            {
                component.hasError     = true;
                component.errorMessage = 'Please select a user type.';
                return;
            }

            var _this = this;
            User.signIn(
                    {
                        username:   component.form.username,
                        password:   component.form.password,
                    },
                    {
                        recaptchaResponse:  recaptchaResponse,
                        userType:           component.form.selected
                    },
                    function successCallback()
                    {
                        component.hasError     = false;
                        component.errorMessage = '';
                        component.$router.push( User.UserEnum.properties[ component.form.selected ].welcomePath );
                    },
                    function failureCallback( error )
                    {
                        if(    error != null
                            && error.response != null
                            && error.response.data != null
                            && error.response.data.error != null
                            && error.response.data.error.code != null
                            && typeof( error.response.data.error.code ) != 'undefined' )
                        {
                            switch( error.response.data.error.code )
                            {
                            case "UserNotConfirmedException":
                                if( User.UserEnum.properties[ component.form.selected ].value === User.UserEnum.PROVIDER )
                                {
                                    component.hasError          = true;
                                    component.errorMessage      = 'User needs to be confirmed.';
                                    component.needsConfirmation = true;
                                }
                                else
                                {
                                    component.hasError     = true;
                                    component.errorMessage = 'Your account has not been confirmed. Please contact the help desk.';
                                }
                                break;
                            default:
                                component.hasError     = true;
                                component.errorMessage = 'An error has occurred while attempting to sign in.';
                                break;
                            }
                        }
                        else
                        {
                            component.hasError     = true;
                            component.errorMessage = 'An error has occurred while attempting to sign in.';
                        }
                    }
                );
        }
        catch( error )
        {
            alert( 'Signin Exception: ' + error );
        }
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onMounted()
    {
        this.recaptchaID = grecaptcha.render(
                                "signin-recaptcha",
                                {
                                    sitekey: process.env.RECAPTCHA_SITE_KEY,
                                }
                            );
    }
</script>


// WEBPACK FOOTER //
// src/components/account/signin.vue